import { createContext, useContext, useEffect, useState } from "react";

const CartContext = createContext(null);

export function CartProvider({ children }) {
  const [items, setItems] = useState(() => {
    try {
      return JSON.parse(localStorage.getItem("volt_cart") || "[]");
    } catch {
      return [];
    }
  });
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    localStorage.setItem("volt_cart", JSON.stringify(items));
  }, [items]);

  const addItem = (product, quantity = 1, option = null) => {
    setItems((prev) => {
      const existing = prev.find((i) => i.product_id === product.id && i.option === option);
      if (existing) {
        return prev.map((i) =>
          i.product_id === product.id && i.option === option ? { ...i, quantity: Math.min(i.quantity + quantity, 99) } : i
        );
      }
      return [...prev, { product_id: product.id, name: product.name, price: product.price, image_url: product.image_url, quantity, option }];
    });
  };

  const addItemMulti = (product, quantity = 1, selections = null) => {
    const label = selections ? Object.entries(selections).map(([k, v]) => `${k}: ${v}`).join(" · ") : null;
    let unitPrice = product.price;
    if (selections && product.option_groups) {
      for (const g of product.option_groups) {
        const chosen = selections[g.label];
        for (const c of g.choices || []) {
          const cname = typeof c === "object" ? c.name : c;
          if (cname === chosen && typeof c === "object" && c.price_modifier) {
            unitPrice += c.price_modifier;
          }
        }
      }
    }
    const newItem = { product_id: product.id, name: product.name, price: unitPrice, image_url: product.image_url, quantity, option: label, selections };
    setItems((prev) => {
      const existing = prev.find((i) => i.product_id === product.id && i.option === label);
      if (existing) {
        return prev.map((i) =>
          i.product_id === product.id && i.option === label ? { ...i, quantity: Math.min(i.quantity + quantity, 99), selections } : i
        );
      }
      return [...prev, newItem];
    });
  };

  const updateQuantity = (productId, quantity) => {
    if (quantity <= 0) {
      removeItem(productId);
      return;
    }
    setItems((prev) => prev.map((i) => (i.product_id === productId ? { ...i, quantity } : i)));
  };

  const removeItem = (productId) => {
    setItems((prev) => prev.filter((i) => i.product_id !== productId));
  };

  const clearCart = () => setItems([]);

  const total = items.reduce((sum, i) => sum + i.price * i.quantity, 0);
  const count = items.reduce((sum, i) => sum + i.quantity, 0);

  return (
    <CartContext.Provider value={{ items, addItem, addItemMulti, updateQuantity, removeItem, clearCart, total, count, isOpen, setIsOpen }}>
      {children}
    </CartContext.Provider>
  );
}

export function useCart() {
  return useContext(CartContext);
}
